import { dateToTime } from '@paperstac/helpers/lib/dateHelpers';
import differenceInSeconds from 'date-fns/differenceInSeconds';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import React from 'react';
const FIVE_SECS_IN_MS = 5000;
const ONE_MINUTE_IN_SECS = 60;
const ONE_MINUTE_IN_MS = ONE_MINUTE_IN_SECS * 1000;
const ONE_HOUR_IN_SECS = ONE_MINUTE_IN_SECS * 60;
const ONE_HOUR_IN_MS = ONE_HOUR_IN_SECS * 1000;
const ONE_DAY_IN_SECS = ONE_HOUR_IN_SECS * 24;
const timeToRelativeDate = time => {
  if (!time) return '';
  return formatDistanceToNow(new Date(time), {
    includeSeconds: true,
    addSuffix: true
  });
};
const useRelativeDate = dateOrFirestoreTimestamp => {
  const time = dateToTime(dateOrFirestoreTimestamp);
  const [relativeDate, setRelativeDate] = React.useState(timeToRelativeDate(time));
  const [relativeDateRefreshed, setRelativeDateRefreshed] = React.useState(null);
  const refreshRelativeDate = React.useCallback(() => {
    setRelativeDate(timeToRelativeDate(time));
    setRelativeDateRefreshed(new Date().getTime());
  }, [time]);
  React.useEffect(() => {
    if (!time) return;
    const diffInSecs = differenceInSeconds(new Date(), new Date(time));
    if (diffInSecs < ONE_MINUTE_IN_SECS) {
      const to = setTimeout(refreshRelativeDate, FIVE_SECS_IN_MS);
      return () => clearTimeout(to);
    }
    if (diffInSecs < ONE_HOUR_IN_SECS) {
      const to = setTimeout(refreshRelativeDate, ONE_MINUTE_IN_MS);
      return () => clearTimeout(to);
    }
    if (diffInSecs < ONE_DAY_IN_SECS) {
      const to = setTimeout(refreshRelativeDate, ONE_HOUR_IN_MS);
      return () => clearTimeout(to);
    }
  }, [time, relativeDateRefreshed, refreshRelativeDate]);
  return relativeDate;
};
export default useRelativeDate;